const MessageHandlerMixin = {
  name: 'MessageHandlerMixin',
  methods: {
    sendMessageToBot: function(text, sessionId) {
      this.$store.state.$socket.emit('user_uttered', {
        message: text,
        room: sessionId
      })
    }
  }
}

export default MessageHandlerMixin
